import { tableCount } from '@models/constants';

export const place = tableCount(true, 'Project');
